"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsCard = void 0;
var solid_1 = require("@heroicons/react/20/solid");
var react_1 = __importStar(require("react"));
require("../../../index.css");
var DateRange_1 = require("../DateRange");
function classNames() {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(Boolean).join(" ");
}
var StatsCard = /** @class */ (function (_super) {
    __extends(StatsCard, _super);
    function StatsCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderGridSize = function () {
            var gridSize = "";
            if (_this.props.gridSize === 1)
                gridSize = "md:grid-cols-1";
            else if (_this.props.gridSize === 2)
                gridSize = "md:grid-cols-2";
            else if (_this.props.gridSize === 3)
                gridSize = "md:grid-cols-2 lg:grid-cols-3";
            else
                gridSize = "md:grid-cols-2 lg:grid-cols-4";
            return gridSize;
        };
        return _this;
    }
    StatsCard.prototype.render = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: classNames(this.renderGridSize(), "grid grid-cols-1 gap-5 divide-y md:divide-y-0 md:divide-x") }, this.props.stats.map(function (item) { return (react_1.default.createElement("div", { key: item.name, className: "bg-white overflow-hidden shadow rounded-lg p-5 lg:mb-3 sm:my-1" },
                react_1.default.createElement("dt", { className: "text-base font-normal text-gray-900 flex flex-row" },
                    react_1.default.createElement("div", { className: "m-1 ml-0" }, item.icon),
                    react_1.default.createElement("div", { className: "self-center ml-1" },
                        " ",
                        item.name)),
                react_1.default.createElement("dd", { className: "mt-1 flex items-baseline justify-between md:block lg:flex" },
                    react_1.default.createElement("div", { className: "flex items-baseline text-2xl font-semibold text-primary-600" },
                        item.stats,
                        item.previousStats && (react_1.default.createElement("span", { className: "ml-2 text-sm font-medium text-gray-500" },
                            "from ",
                            item.previousStats))),
                    item.change && (react_1.default.createElement("div", { className: classNames(item.changeType === "increase"
                            ? "bg-green-100 text-green-800"
                            : "bg-red-100 text-red-800", "inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium md:mt-2 lg:mt-0") },
                        item.changeType === "increase" ? (react_1.default.createElement(solid_1.ArrowUpIcon, { className: "-ml-1 mr-0.5 h-5 w-5 flex-shrink-0 self-center text-green-500", "aria-hidden": "true" })) : (react_1.default.createElement(solid_1.ArrowDownIcon, { className: "-ml-1 mr-0.5 h-5 w-5 flex-shrink-0 self-center text-red-500", "aria-hidden": "true" })),
                        item.change))))); })),
            this.props.dateRangeVisible && (react_1.default.createElement(DateRange_1.DateRange, { customDate: this.props.customDate, onChangeDate: this.props.onChangeDate }))));
    };
    return StatsCard;
}(react_1.Component));
exports.StatsCard = StatsCard;
//# sourceMappingURL=index.js.map